var IconNames = {
    extraSmall: [
        'action__add',
        'action__bookmark',
        'action__caret-down',
        'action__caret-left',
        'action__caret-right',
        'action__caret-up',
        'action__check',
        'action__close',
        'action__edit',
        'action__hide',
        'action__logout',
        'action__next',
        'action__open-link',
        'action__previous',
        'action__search',
        'action__share',
        'action__show',
        'action__sort-arrow',
        'action__subtract',
        'action__thumbs-up',
        'action__unsorted-arrow',
        'action__value-decrease',
        'action__value-increase',
        'logo__facebook',
        'logo__linkedin',
        'logo__twitter',
        'logo__youtube',
        'nav__overflow-vertical',
        'nav__profile',
        'nav__menu',
        'status__notification',
        'status__star--outline',
        'status__star',
    ],
};

export { IconNames as default };
//# sourceMappingURL=icon-names.js.map
